// src/components/Button.tsx

import { Tooltip } from 'antd';
import React from 'react';
import './style.scss';

interface IconButtonProps {
  tip: string | React.ReactNode; // 定义可用的样式变体
  children: React.ReactNode; // 按钮内的内容
  onClick?: () => void; // 点击事件处理函数
  className?: string; // 额外的 CSS 类
  disabled?: boolean; // 按钮是否禁用
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'bottomLeft' | 'bottomRight'; // 提示框位置
}

const IconButton: React.FC<IconButtonProps> = ({
  tip,
  children,
  onClick,
  className,
  placement = 'top',
}) => {
  return (
    <Tooltip
      key={tip?.toString() ?? ''}
      placement={placement}
      zIndex={1040}
      title={tip}
      arrow={false}
      overlayClassName='icon-button-tooltip '
    >
      <div
        onClick={onClick}
        className={`md:hover:bg-col_bg03 flex h-7 w-7 cursor-pointer items-center justify-center rounded-[8px] ${
          className ?? ''
        }`}
      >
        {children}
      </div>
    </Tooltip>
  );
};

export { IconButton };
